import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export const STRIPE_SUBSCRIPTION_STATUS_LABEL: Readonly<Record<string, string>> = {
  active: 'backoffice.enums.stripe_status.active',
  trialing: 'backoffice.enums.stripe_status.trialing',
  past_due: 'backoffice.enums.stripe_status.past_due',
  unpaid: 'backoffice.enums.stripe_status.unpaid',
  canceled: 'backoffice.enums.stripe_status.canceled',
  paused: 'backoffice.enums.stripe_status.paused',
  incomplete: 'backoffice.enums.stripe_status.incomplete',
  incomplete_expired: 'backoffice.enums.stripe_status.incomplete_expired',
};

export const STRIPE_SUBSCRIPTION_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  active: 'positive',
  trialing: 'info',
  past_due: 'warning',
  unpaid: 'danger',
  canceled: 'neutral',
  paused: 'warning',
  incomplete: 'warning',
  incomplete_expired: 'neutral',
};

export const INVOICE_STATUS_LABEL: Readonly<Record<string, string>> = {
  draft: 'backoffice.enums.invoice_status.draft',
  open: 'backoffice.enums.invoice_status.open',
  paid: 'backoffice.enums.invoice_status.paid',
  uncollectible: 'backoffice.enums.invoice_status.uncollectible',
  void: 'backoffice.enums.invoice_status.void',
};

export const INVOICE_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  draft: 'neutral',
  open: 'warning',
  paid: 'positive',
  uncollectible: 'danger',
  void: 'neutral',
};

export const INVOICE_STATUS_OPTIONS: readonly string[] = [
  'draft',
  'open',
  'paid',
  'uncollectible',
  'void',
];

export const PAYMENT_STATUS_LABEL: Readonly<Record<string, string>> = {
  succeeded: 'backoffice.enums.payment_status.succeeded',
  failed: 'backoffice.enums.payment_status.failed',
  requires_action: 'backoffice.enums.payment_status.requires_action',
  requires_payment_method: 'backoffice.enums.payment_status.requires_payment_method',
  pending: 'backoffice.enums.payment_status.pending',
};

export const PAYMENT_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  succeeded: 'positive',
  failed: 'danger',
  requires_action: 'warning',
  requires_payment_method: 'warning',
  pending: 'neutral',
};

export const PAYMENT_STATUS_OPTIONS: readonly string[] = [
  'succeeded',
  'failed',
  'requires_action',
  'requires_payment_method',
  'pending',
];
